import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c0058d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ModalTableShop_Content" }
const _hoisted_2 = { class: "ModalTableShop_Header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ModalTableShop_Header_Title" }, "注文別商品入力", -1))
const _hoisted_4 = { class: "ModalTableShop_Main" }
const _hoisted_5 = { class: "ModalTableShop_Middle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModalTableShop_Middle_Title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ModalTableShop_Middle_Title_Line" }),
  /*#__PURE__*/_createElementVNode("p", null, "対象書店")
], -1))
const _hoisted_7 = { class: "ModalTableShop_TableContainer" }
const _hoisted_8 = { class: "ModalTableShop_Table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModalTableShop_Middle_Title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ModalTableShop_Middle_Title_Line" }),
  /*#__PURE__*/_createElementVNode("p", null, "対象商品")
], -1))
const _hoisted_13 = { class: "ModalTableShop_SelectList" }
const _hoisted_14 = { class: "ModalTableShop_TableContainer" }
const _hoisted_15 = { class: "ModalTableShop_Table" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = {
  key: 3,
  class: "ModalTableShop_Button disabled_btn",
  style: {"margin-left":"5px"}
}
const _hoisted_24 = { class: "ModalTableShop_Table_Syosi ModalTableShop_Table_Sticky_TB Text_Left" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["onUpdate:modelValue", "onFocus", "onChange", "onBlur"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["value"]
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["value"]
const _hoisted_35 = { style: {"display":"flex"} }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = ["onInput", "value"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ModalTableShop_Table_Error" }, "※「短冊メモ」は全角16文字以内で入力してください", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "ModalTableShop_Bottom" }

import BtnGreen from "../atoms/button/BtnGreen.vue";
import BtnWhite from "../atoms/button/BtnWhite.vue";
import BadgeHold from "../atoms/Badge/BadgeHold.vue";
import selectBarSingle from "../molecules/selectBarSingle.vue";
import { ref } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { ResItems } from "../TableShop.vue";
import { Notyf } from "notyf";
import ModalMultiTanzaku from "./ModalMultiTanzaku.vue";

interface ItemDetails extends ResItems {
  hasTanzakuError: boolean;
  selectFlg: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalTableShop',
  props: {
  toritugiCd: { type: String, required: true },
  toritugiSyotenCd: { type: String, required: true },
  bansen: { type: String, required: true },
},
  emits: ["close", "updatedCart", "deleteItem"],
  setup(__props, { emit: __emit }) {

const notyf = new Notyf();
const store = useStore();
const props = __props;
const emit = __emit;
const closeModal = () => {
  emit("close");
};
const userInfo = store.getters["login/getUserData"];
//営業担当者
const salesList = store.getters["constant/getSalesList"];

//テーブル表示項目--------------------------------------------
const headers_top = ref([{ title: "書店CD", titleB: "書店名" }]);
const headers_middle = ref([
  { title: "書誌CD", titleB: "ISBN", titleC: "書誌名", stickyFlg: true },
  { title: "本体価格", stickyFlg: false },
  { title: "注文数", stickyFlg: false },
  { title: "注文種別", stickyFlg: false },
  { title: "保留設定", stickyFlg: false },
  { title: "営業担当者", stickyFlg: false },
  { title: "短冊メモ", stickyFlg: false },
  { title: "削除", stickyFlg: false },
]);
let initialData = [] as ResItems[];
const itemDetails = ref([] as ItemDetails[]);
const getItemDetail = async () => {
  try {
    const url = `${store.getters["getBaseUrl"]}/chumon/multi/eachSyotenCartData?hanmotoCd=${userInfo.hanmotoCd}&userId=${userInfo.userId}&toritugiCd=${props.toritugiCd}&toritugiSyotenCd=${props.toritugiSyotenCd}&bansen=${props.bansen}`;
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    initialData = res.data as ResItems[];
    itemDetails.value.splice(0);
    res.data.forEach((data: ResItems) => {
      itemDetails.value.push({
        hasTanzakuError: false,
        selectFlg: false,
        ...data,
      });
    });
  } catch (error) {
    console.log(error);
    alert("注文内容が取得できませんでした");
  }
};
getItemDetail();

//一括選択のセレクトバー関連--------------------------------------------
let highLightTargrt = ref("");
let selectBar_syubetu = ref({
  title: "注文種別一括",
  select_list: [
    { name: "補充", selectFlg: false, value: 0 },
    { name: "客注", selectFlg: false, value: 1 },
  ],
});
let selectBar_hold = ref({
  title: "保留設定一括",
  select_list: [
    { name: "保留", selectFlg: false, value: true },
    { name: "保留しない", selectFlg: false, value: false },
  ],
});
const updateSelectSyubetu = (
  newVal: typeof selectBar_syubetu.value.select_list[0]
) => {
  itemDetails.value.forEach((item) => {
    item.juchuKbn = newVal.value;
  });
  // // 変更ハイライト(1秒後に削除)
  addHighLight("syubetu");
};
const updateSelectHold = (
  newVal: typeof selectBar_hold.value.select_list[0]
) => {
  itemDetails.value.forEach((item) => {
    if (newVal.name == "保留") {
      item.hold = true;
    } else {
      item.hold = false;
    }
  });
  // // 変更ハイライト(1秒後に削除)
  addHighLight("hold");
};
const addHighLight = (higthLightTarget: string) => {
  highLightTargrt.value = higthLightTarget;
  setTimeout(() => {
    highLightTargrt.value = "";
  }, 1000);
};

// 入力関連--------------------------------------------------
// 注文数
let holdQuantity = 0;
const focusQuantity = (e: any, index: number) => {
  holdQuantity = Number(e.target.value);
  itemDetails.value[index].quantity = null;
};
const blurQuantity = (e: any, index: number) => {
  if (e.target.value === "") {
    itemDetails.value[index].quantity = holdQuantity;
  }
  holdQuantity = 0;
};
const validateQuantity = (e: any, index: number) => {
  //符号無し整数を判定
  if (
    !e.target.value.match(/^[0-9]+$/) ||
    isValidQuantity(itemDetails.value[index])
  ) {
    itemDetails.value[index].quantity = holdQuantity;
  }
};
const isValidQuantity = (item: ItemDetails) => {
  if (item.quantity === null || Number(item.quantity) === 0) {
    return true;
  } else {
    return false;
  }
};
// 短冊メモ
const inputTanzaku = (e: any, item: ItemDetails) => {
  item.tanzkau = e.target.value;
  if (isValidTanzaku(item)) item.hasTanzakuError = true;
  else item.hasTanzakuError = false;
};
const isValidTanzaku = (item: ItemDetails) => {
  if (
    item.tanzkau.length &&
    (item.tanzkau.length > 16 || !isZenkaku(item.tanzkau))
  ) {
    return true;
  } else {
    return false;
  }
};
const isZenkaku = (value: string) => {
  // eslint-disable-next-line no-control-regex
  const pattern = /^[^\x01-\x7E\uFF61-\uFF9F]+$/;
  return value.match(pattern);
};
// 一括編集
// 編集ボタン制御
const showAllTanzakuEditBtn = ref(false);
const checkSelectFlg = () => {
  let isSelected = false;
  itemDetails.value.forEach((list) => {
    if (list.selectFlg) isSelected = true;
  });
  showAllTanzakuEditBtn.value = isSelected;
};
// 編集ボタンクリック
const clickAllTanzakuEdit = () => {
  showTanzakuModal();
};
// 短冊一括設定モーダル
const tanzakuModalVisible = ref(false); // 短冊モーダル表示制御フラグ
const showTanzakuModal = () => {
  tanzakuModalVisible.value = true;
};
const closeTanzakuModal = () => {
  tanzakuModalVisible.value = false;
};
const addTanzakuInfo = (tanzakuData: { memo: string }) => {
  itemDetails.value.forEach((list) => {
    if (list.selectFlg) list.tanzkau = tanzakuData.memo;
  });
  tanzakuModalVisible.value = false;
};

// 削除関連-----------------------------------------------------------------
const deleteItem = async (item: ItemDetails) => {
  if (confirm(`「${item.title}」を削除してもよろしいですか？`)) {
    try {
      // const url = `${
      //   store.getters["getBaseUrl"]
      // }/chumon/multi/deleteSyosiCartData?hanmotoCd=${userInfo.hanmotoCd}&userId=${
      //   userInfo.userId
      // }&janCd=${item.janCd}&toritugiCd=${item.toritugiCd}&toritugiSyotenCd=${
      //   item.toritugiSyotenCd
      // }&tanzaku=${item.tanzkau}&bansen=${item.bansen}&juchuKbn=${
      //   item.juchuKbn
      // }&isUpdate=${true}&isHold=${item.hold}`;
      const sendData = [
        {
          hanmotoCd: userInfo.hanmotoCd,
          userId: userInfo.userId,
          janCd: item.janCd,
          quantity: item.quantity,
          toritugiCd: item.toritugiCd,
          toritugiSyotenCd: item.toritugiSyotenCd,
          tanzaku: item.tanzkau,
          bansen: item.bansen,
          juchuKbn: item.juchuKbn,
          isUpdate: true,
          isHold: item.hold,
        },
      ];
      await axios.post(
        `${store.getters["getBaseUrl"]}/chumon/multi/deleteSyosiCartData`,
        sendData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      notyf.success(`${item.title}を削除しました`);
      getItemDetail();
      emit("deleteItem");
    } catch (error) {
      console.log(error);
      alert("削除に失敗しました");
    }
  }
};

// カート反映---------------------------------------------------------
const refCart = async () => {
  // バリデーション
  for (let item of itemDetails.value) {
    if (item.hasTanzakuError) {
      notyf.error("入力内容を確認してください");
      return;
    }
  }

  try {
    let sendData = [] as any[];
    itemDetails.value.forEach((item, index) => {
      sendData.push({
        hanmotoCd: userInfo.hanmotoCd,
        userId: userInfo.userId,
        janCd: item.janCd,
        quantity: item.quantity,
        toritugiCd: item.toritugiCd,
        toritugiSyotenCd: item.toritugiSyotenCd,
        tanzaku: item.tanzkau,
        bansen: item.bansen,
        juchuKbn: item.juchuKbn,
        isUpdate: judgeUpdated(index),
        isHold: item.hold,
        salesCd: item.salesCd,
      });
    });

    const res = await axios.patch(
      `${store.getters["getBaseUrl"]}/chumon/multi/updateEachSyotenCartData`,
      sendData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    notyf.success("カートに反映しました");
    emit("updatedCart");
  } catch (error) {
    console.log(error);
    notyf.error("カートの反映に失敗しました");
  }
};

/**
 * データが更新されているか否か判定する
 */
const judgeUpdated = (index: number) => {
  if (
    Number(itemDetails.value[index].quantity) !==
    Number(initialData[index].quantity)
  ) {
    return true;
  } else if (
    itemDetails.value[index].juchuKbn !== initialData[index].juchuKbn
  ) {
    return true;
  } else if (itemDetails.value[index].hold !== initialData[index].hold) {
    return true;
  } else if (itemDetails.value[index].tanzkau !== initialData[index].tanzkau) {
    return true;
  } else if (itemDetails.value[index].salesCd !== initialData[index].salesCd) {
    return true;
  } else {
    return false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (tanzakuModalVisible.value)
      ? (_openBlock(), _createBlock(ModalMultiTanzaku, {
          key: 0,
          onClose: closeTanzakuModal,
          onAddTanzakuInfo: addTanzakuInfo
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "ModalTableShop",
      onClick: closeModal
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_font_awesome_icon, {
          onClick: closeModal,
          class: "ModalTableShop_Header_Close",
          icon: "xmark"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers_top.value, (header, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: index,
                      class: "ModalTableShop_Table_Tate"
                    }, [
                      (!header.titleB)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(header.title), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(header.title) + "/" + _toDisplayString(header.titleB), 1))
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(itemDetails.value[0]?.toritugiSyotenCd), 1),
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(itemDetails.value[0]?.toritugiSyotenMei), 1)
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(selectBarSingle, {
              selectBarList_props: _unref(selectBar_syubetu),
              onUpdateSelectValue: updateSelectSyubetu
            }, null, 8, ["selectBarList_props"]),
            _createVNode(selectBarSingle, {
              selectBarList_props: _unref(selectBar_hold),
              onUpdateSelectValue: updateSelectHold
            }, null, 8, ["selectBarList_props"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("table", _hoisted_15, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers_middle.value, (header, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: index,
                      class: _normalizeClass({
                      ModalTableShop_Table_Syosi: header.title == '書誌CD',
                      ModalTableShop_Table_Sticky_TH: header.stickyFlg,
                    })
                    }, [
                      (!header.titleB)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(header.title), 1))
                        : _createCommentVNode("", true),
                      (header.titleB)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            (header.titleC)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                  _createTextVNode(_toDisplayString(header.title), 1),
                                  _hoisted_19,
                                  _createTextVNode(_toDisplayString(header.titleB), 1),
                                  _hoisted_20,
                                  _createTextVNode(_toDisplayString(header.titleC), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                  _createTextVNode(_toDisplayString(header.title), 1),
                                  _hoisted_22,
                                  _createTextVNode(_toDisplayString(header.titleB), 1)
                                ]))
                          ]))
                        : _createCommentVNode("", true),
                      (
                        header.title === '短冊メモ' && showAllTanzakuEditBtn.value
                      )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: clickAllTanzakuEdit,
                            class: "ModalTableShop_Button GreenSmall",
                            style: {"margin-left":"5px"}
                          }, " 一括編集 "))
                        : (
                        header.title === '短冊メモ' && !showAllTanzakuEditBtn.value
                      )
                          ? (_openBlock(), _createElementBlock("button", _hoisted_23, " 一括編集 "))
                          : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemDetails.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_24, [
                      _createTextVNode(_toDisplayString(item.syosiCd), 1),
                      _hoisted_25,
                      _createTextVNode(_toDisplayString(item.janCd), 1),
                      _hoisted_26,
                      _createTextVNode(_toDisplayString(item.title) + " ", 1),
                      (item.hold)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                            _createVNode(BadgeHold)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.hontaiPrice?.toLocaleString()) + "円", 1),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "ModalTableShop_Table_Input",
                        "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                        onFocus: ($event: any) => (focusQuantity($event, index)),
                        onChange: ($event: any) => (validateQuantity($event, index)),
                        onBlur: ($event: any) => (blurQuantity($event, index))
                      }, null, 40, _hoisted_28), [
                        [_vModelText, item.quantity]
                      ])
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass({ selectHighLight: _unref(highLightTargrt) === 'syubetu' })
                    }, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((item.juchuKbn) = $event),
                        class: _normalizeClass({
                        selectHighLight: _unref(highLightTargrt) === 'syubetu',
                      })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectBar_syubetu).select_list, (syubetu, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: syubetu.value
                          }, _toDisplayString(syubetu.name), 9, _hoisted_30))
                        }), 128))
                      ], 10, _hoisted_29), [
                        [_vModelSelect, item.juchuKbn]
                      ])
                    ], 2),
                    _createElementVNode("td", {
                      class: _normalizeClass({ selectHighLight: _unref(highLightTargrt) === 'hold' })
                    }, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((item.hold) = $event),
                        class: _normalizeClass({ selectHighLight: _unref(highLightTargrt) === 'hold' })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectBar_hold).select_list, (hold, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: index,
                            value: hold.value
                          }, _toDisplayString(hold.name), 9, _hoisted_32))
                        }), 128))
                      ], 10, _hoisted_31), [
                        [_vModelSelect, item.hold]
                      ])
                    ], 2),
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((item.salesCd) = $event)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(salesList), (option, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: option.salesCd,
                            key: index
                          }, _toDisplayString(option.salesName), 9, _hoisted_34))
                        }), 128))
                      ], 8, _hoisted_33), [
                        [_vModelSelect, item.salesCd]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_35, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((item.selectFlg) = $event),
                          onChange: checkSelectFlg,
                          style: {"margin-right":"5px"}
                        }, null, 40, _hoisted_36), [
                          [_vModelCheckbox, item.selectFlg]
                        ]),
                        _createElementVNode("input", {
                          type: "text",
                          class: "ModalTableShop_Table_Input_Long",
                          onInput: ($event: any) => (inputTanzaku($event, item)),
                          value: item.tanzkau
                        }, null, 40, _hoisted_37)
                      ]),
                      (item.hasTanzakuError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_38, _hoisted_40))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "ModalTableShop_Table_Icon",
                        icon: "trash-can",
                        onClick: ($event: any) => (deleteItem(item))
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createVNode(BtnGreen, {
            class: "ModalTableShop_Btn",
            onClick: refCart
          }, {
            default: _withCtx(() => [
              _createTextVNode("カートに反映")
            ]),
            _: 1
          }),
          _createVNode(BtnWhite, {
            class: "ModalTableShop_Btn",
            onClick: closeModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("閉じる")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})